export const categories = {
    "general": 9,
    "computer-science": 18,
    "books": 10,
    "films": 11,
    "music": 12
}